import ModalCreateInvitePatient from "./ModalCreateInvitePatient";

export default ModalCreateInvitePatient;